import React from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";
import { Alert } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { faPlus, faEdit } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Button from "./CustomButton";
import { set } from "lodash";
import { compose, setDisplayName } from "recompose";
import NextForm from "../containers/NextForm";

export const CustomerForm = props => {
  const {
    currentCustomer,
    failMessage,
    loadingSubmitCustomer,
    onSubmit,
    inputs,
    focusNextField,
    initialValues
  } = props;
  return (
    <Formik
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      render={props => (
        <Form>
          {failMessage && <Alert color="danger">{failMessage}</Alert>}
          <Field
            innerRef={input => (inputs.first_name = input)}
            onKeyPress={focusNextField("last_name")}
            name="first_name"
            component={TextInput}
            placeholder="Customer's First Name"
            label="First Name"
          />
          <Field
            innerRef={input => (inputs.last_name = input)}
            onKeyPress={focusNextField("email")}
            name="last_name"
            component={TextInput}
            placeholder="Customer's Last Name"
            label="Last Name"
          />
          <Field
            innerRef={input => (inputs.email = input)}
            onKeyPress={focusNextField("phone_number")}
            name="email"
            type="email"
            component={TextInput}
            placeholder="Customer's Email"
            label="Email"
          />
          <Field
            innerRef={input => (inputs.phone_number = input)}
            name="phone_number"
            component={TextInput}
            placeholder="Customer's Phone Number"
            label="Phone Number"
          />
          <div>
            <Button
              fill
              type="submit"
              disabled={loadingSubmitCustomer}
              color="primary"
            >
              {currentCustomer ? "Update" : "Create"} Customer{" "}
              <FontAwesomeIcon icon={currentCustomer ? faEdit : faPlus} />
            </Button>
          </div>
        </Form>
      )}
    />
  );
};

CustomerForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  loadingSubmitCustomer: PropTypes.bool.isRequired,
  failureSubmitCustomer: PropTypes.string,
  initialValues: PropTypes.object.isRequired
};

export const validate = (values = {}) => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  const errors = {};
  if (!values.first_name) {
    set(errors, "first_name", "Required");
  }
  if (!values.last_name) {
    set(errors, "last_name", "Required");
  }
  if (!values.email && !values.phone_number) {
    set(errors, "email", "Required");
    set(errors, "phone_number", "Required");
  } else if (!emailRegex.test(values.email) && !values.phone_number) {
    set(errors, "email", "Invalid email");
  }
  return errors;
};

export default compose(
  setDisplayName("CustomerForm"),
  NextForm
)(CustomerForm);
